import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";
import { isAsyncIterable, isIterable } from "../_internal/utils.js";
import { AsyncFunctionException } from "../_internal/error.js";

function sync(f, iterable) {
  var iterator = iterable[Symbol.iterator]();
  return _defineProperty({
    next: function next() {
      var _iterator$next = iterator.next(),
          done = _iterator$next.done,
          value = _iterator$next.value;

      if (done) {
        return {
          done: true,
          value: undefined
        };
      }

      var res = f(value);

      if (res instanceof Promise) {
        throw new AsyncFunctionException();
      }

      return {
        done: false,
        value: res
      };
    }
  }, Symbol.iterator, function () {
    return this;
  });
}

function async(f, iterable) {
  var iterator = iterable[Symbol.asyncIterator]();
  return _defineProperty({
    next: function next(_concurrent) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$iterator$next, done, value;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return iterator.next(_concurrent);

              case 2:
                _yield$iterator$next = _context.sent;
                done = _yield$iterator$next.done;
                value = _yield$iterator$next.value;

                if (!done) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", {
                  done: done,
                  value: value
                });

              case 7:
                _context.next = 9;
                return f(value);

              case 9:
                _context.t0 = _context.sent;
                return _context.abrupt("return", {
                  done: false,
                  value: _context.t0
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}

function map(f, iterable) {
  if (iterable === undefined) {
    return function (iterable) {
      return map(f, iterable);
    };
  }

  if (isIterable(iterable)) {
    return sync(f, iterable);
  }

  if (isAsyncIterable(iterable)) {
    return async(f, iterable);
  }

  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}

export default map;